import React, { useState } from 'react';
import styles from './Lms.module.css';
import ButtonComponent from '../../CssComponents/ButtonComponent/ButtonComponent';
import ListModule from './ListModule/ListModule';
import ListCourse from './ListCourse/ListCourse';
import ListBatch from './ListBatch/ListBatch';
import ListPackage from './ListPackage/ListPackage';

function Lms() {
    const [activeList, setActiveList] = useState(null);

    const openList = (modalType) => {
        setActiveList(modalType);
    };

    const renderListContent = () => {
        switch (activeList) {
            case 'package':
                return <ListPackage />;
            case 'batch':
                return <ListBatch />;
            case 'courses':
                return <ListCourse />;
            case 'module':
                return <ListModule />;
            default:
                return null;
        }
    };

    return (
        <>
            <div className={styles.lmsContainer}>
                <h1 className={styles.heading}>What do you want to add ?</h1>
                <div className={styles.buttonContainer}>


                    <ButtonComponent
                        onClick={() => openList('package')}
                        buttonText={'Package'}
                    />

                    <ButtonComponent
                        onClick={() => openList('batch')}
                        buttonText={'Batch'}
                    />

                    <ButtonComponent
                        onClick={() => openList('courses')}
                        buttonText={'Courses'}
                    />

                    <ButtonComponent
                        onClick={() => openList('module')}
                        buttonText={'Module'}
                    />
                </div>
                {renderListContent()}
            </div>
        </>
    );
}

export default Lms;
